import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";

import { COLORS } from "common/colors";
import { ERRORS, LABELS, SUB_TITLES, SUCCESS, TITLES } from "common/lables";
import { DEFAULTS, NOTIFY } from "common/config";
import { MASTER_APIs } from "apihandlers/master";
import { COMMON_JS } from "common/scripts";

const LeaveType = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>([]);

  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await MASTER_APIs.getLeaveTypes(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getRegions:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };
  const reloadGrid = () => {
    setRows(null);
    getRows();
  };
  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "nameOfHoliday",
      name: LABELS.NAME,
      width: "35%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "dateOfHoliday",
      name: LABELS.DATE,
      width: "35%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "20%",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
    },

    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageHolidays = () => {
    const name = (
      document.getElementById("name") as HTMLInputElement
    ).value.trim();
    const maxDays = (
      document.getElementById("maxDays") as HTMLInputElement
    ).value.trim();

    let op = document.querySelector(
      'input[name="isMonthly"]:checked'
    ) as HTMLInputElement;
    const isMonthly = op ? op.value : "";
    op = document.querySelector(
      'input[name="isLop"]:checked'
    ) as HTMLInputElement;
    const isLop = op ? op.value : "";

    let active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = active ? active.value : "";

    // let errors = [];
    // if (!nameOfHoliday) {
    //   errors.push({
    //     id: "userTypeId",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.USER_ROLE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }

    // setMandatoryResults(errors);
    // if (errors.length > 0) {
    //   COMMON_JS.showNotify(
    //     props,
    //     NOTIFY.WARNING,
    //     WARNINGS.PLEASE_CHECK_FORM_ERRORS
    //   );
    //   return;
    // }

    const args = {
      id: selectedRow.id || -1,

      name,
      maxDays,
      isMonthly,
      isLop,
      activeStatus,
    };
    console.log("args :", args);

    setIsSubmit(true);
    MASTER_APIs.manageLeaveTypes(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME} </li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.LEAVE_TYPE}</li>
        </ul>
        <h4>{TITLES.LEAVE_TYPE}</h4>
        <p>{SUB_TITLES.LEAVE_TYPE}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.LEAVE_TYPE}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.LEAVE_TYPE + ": " + selectedRow.nameOfHoliday
              : "Add New " + LABELS.LEAVE_TYPE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup ">
            <TxtRow
              id={"name"}
              type={"text"}
              label={LABELS.NAME}
              defaultValue={selectedRow.nameOfHoliday}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"maxDays"}
              type={"number"}
              label={LABELS.MAX_DAYS}
              defaultValue={
                selectedRow.id
                  ? Number(selectedRow.nameOfHoliday).toString()
                  : selectedRow.nameOfHoliday
              }
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup ">
            <label>
              {LABELS.IS_MONTHLY}
              {/* {<span className="red">*</span>} */}
            </label>
            <RadioBtn
              list={[
                {
                  id: "yes",
                  value: LABELS.YES,
                  label: LABELS.YES,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === "Yes"
                    : true,
                  disabled: false,
                },
                {
                  id: "no",
                  value: LABELS.NO,
                  label: LABELS.NO,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === "No"
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"isMonthly"}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup ">
            <label>
              {LABELS.IS_LOP}
              {/* {<span className="red">*</span>} */}
            </label>
            <RadioBtn
              list={[
                {
                  id: "yes",
                  value: LABELS.YES,
                  label: LABELS.YES,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === "Yes"
                    : true,
                  disabled: false,
                },
                {
                  id: "no",
                  value: LABELS.NO,
                  label: LABELS.NO,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === "No"
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"isLop"}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup  ">
            <label>
              {LABELS.STATUS} {<span className="red">*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className=" flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageHolidays}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(LeaveType);
